import { render } from "./AppointmentHistoryListItem.vue?vue&type=template&id=3331fa6a"
import script from "./AppointmentHistoryListItem.vue?vue&type=script&lang=js"
export * from "./AppointmentHistoryListItem.vue?vue&type=script&lang=js"

import "./AppointmentHistoryListItem.vue?vue&type=style&index=0&id=3331fa6a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__